import React, { Component } from 'react';
import '../assets/css/LoginScreen.css';
import logo from '../assets/image/SaxonyCrest.png';
import logoE from '../assets/image/eRechnungLogo.png';

export default class AppContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: ''
    }
  }

  login() {
    // console.log(this.state.username + ' ' + this.state.password)
    this.props.login(this.state.username, this.state.password)
  }

  render() {
    return (
      <div>
        <div className='logoContainer'>
          <img src={logo} id='logo' alt='logo' />
          <img src={logoE} id='logoE' alt='logoERechnung' />
        </div>
        <div className='loginContainer'>
          <div className='content'>
            <h3>Bitte melden Sie sich an um fortzufahren</h3>
            <br />
            <br />
            <form onSubmit={(event) => { this.login(); event.preventDefault(); }}>
              <input placeholder='Benutzername' value={this.state.username} onChange={(event) => this.setState({ username: event.target.value })} />
              <br />
              <input placeholder='Passwort' type='password' value={this.state.password} onChange={(event) => this.setState({ password: event.target.value })} />
              <br />
              <input type='submit' value='Anmelden' className='button' />
            </form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/LoginScreen.js